import { TranslateLoader, provideTranslateService } from '@ngx-translate/core';
import {
  AuthorizationService,
  COMMONS_ENVIRONMENT,
  ConfigLoader,
  DefaultConfigLoader,
  HttpClientLoaderTranslation,
  OAuthInterceptor,
  ServerSettingsService,
  SettingsService,
  W3hostnameInterceptor,
} from '@infodata-group/inf-commons';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { CustomAuthorizationService } from '@monorepo-projects/absence-shared';

export const commonsProvidersFrom = [

];

export const commonsProviders = [
  ...provideTranslateService({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpClientLoaderTranslation,
      deps: [HttpClient],
    },
  }),
  { provide: COMMONS_ENVIRONMENT, useValue: environment },
  { provide: ConfigLoader, useClass: DefaultConfigLoader },
  { provide: AuthorizationService, useClass: CustomAuthorizationService },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: W3hostnameInterceptor,
    multi: true,
  },
  { provide: HTTP_INTERCEPTORS, useClass: OAuthInterceptor, multi: true },
  { provide: SettingsService, useClass: ServerSettingsService },
];
